import { accountApi } from "./accountApi";
import { appAccountApi } from './appAccountApi';
import { appBaiVietApi } from './appBaiVietApi';
import { appBaiVietTrangThaiApi } from './appBaiVietTrangThaiApi';
import { appMenuApi } from './appMenuApi';
import { appMenuNhomApi } from './appMenuNhomApi';
import { appMenuTruongApi } from './appMenuTruongApi';
import { appXinNghiApi } from './appXinNghiApi';
import { appYeuCauHoTroApi } from "./appYeuCauHoTroApi";
import { baiTapApi } from './baiTapApi';
import { baiTapKetQuaApi } from './baiTapKetQuaApi';
import { baiTapTypeApi } from './baiTapTypeApi';
import { categorySourceApi } from "./categorySourceApi";
import { chienDichApi } from "./chienDichApi";
import { crmHocSinhApi } from "./crmHocSinhApi";
import { crmSurveyApi } from "./crmSurveyApi";
import { crmSurveyFormApi } from "./crmSurveyFormApi";
import { crmSurveyFormQuestionApi } from "./crmSurveyFormQuestionApi";
import { dgdkKetQuaHocTapApi } from "./dgdkKetQuaHocTapApi";
import { dgdkKetQuaNlpcApi } from './dgdkKetQuaNlpcApi';
import { dgtxKetQuaApi } from './dgtxKetQuaApi';
import { dgtxKetQuaHocTapApi } from './dgtxKetQuaHocTapApi';
import { dictionaryApi } from "./dictionaryApi";
import { diemDanhApi } from './diemDanhApi';
import { diemDanhStatusApi } from './diemDanhStatusApi';
import { diemVanMinhKetQuaApi } from './diemVanMinhKetQuaApi';
import { diemVanMinhTieuChiApi } from './diemVanMinhTieuChiApi';
import { foCaAnApi } from "./foCaAnApi";
import { foCaAnTruongApi } from "./foCaAnTruongApi";
import { foMonAnChiTietApi } from "./foMonAnChiTietApi";
import { formApi } from "./formApi";
import { formEditorApi } from "./formEditorApi";
import { formEditorTypeApi } from "./formEditorTypeApi";
import { formItemApi } from "./formItemApi";
import { formRegisterResultApi } from "./formRegisterResultApi";
import { formRegisterResultDetailApi } from "./formRegisterResultDetailApi";
import { foThucDonApi } from "./foThucDonApi";
import { giaoVienApi } from "./giaoVienApi";
import { giaoVienNhanXetApi } from './giaoVienNhanXetApi';
import { hocKyApi } from './hocKyApi';
import { hocSinhAceChiTietApi } from "./hocSinhAceChiTietApi";
import { hocSinhAceApi } from "./hocSinhAceApi";
import { hocSinhApi } from "./hocSinhApi";
import { loaiGiayToApi } from "./loaiGiayToApi";
import { loaiPhongApi } from './loaiPhongApi';
import { loaiSucKhoeApi } from "./loaiSucKhoeApi";
import { localizedReourceApi } from './localizedReourceApi';
import { lopApi } from "./lopApi";
import { lopBoMonApi } from "./lopBoMonApi";
import { lopBoMonHocSinhApi } from './LopBoMonHocSinhApi';
import { lopChuNhiemApi } from './lopChuNhiemApi';
import { monHocApi } from "./monHocApi";
import { nguonBietToiApi } from "./nguonBietToiApi";
import { nguonBietToiTypeApi } from "./nguonBietToiTypeApi";
import { nhanXetHangNgayApi } from './nhanXetHangNgayApi';
import { notifyApi } from './notifyApi';
import { phongHocApi } from './phongHocApi';
import { phuHuynhApi } from "./phuHuynhApi";
import { plNamHocApi } from './plNamHocApi';
import { soNhanXetApi } from './soNhanXetApi';
import { soNhanXetItemApi } from './soNhanXetItemApi';
import { sucKhoeApi } from "./sucKhoeApi";
import { thaiDoHocTapApi } from './thaiDoHocTapApi';
import { thaiDoHocTapTieuChiApi } from './thaiDoHocTapTieuChiApi';
import { thoiKhoaBieuApi } from './thoiKhoaBieuApi';
import { thoiKhoaBieuChiTietApi } from './thoiKhoaBieuChiTietApi';
import { thongTuApi } from './thongTuApi';
import { thuApi } from './thuApi';
import { tietApi } from './tietApi';
import { toKhoiApi } from "./toKhoiApi";
import { tongHopDinhKyApi } from "./tongHopDinhKyApi";
import { trangThaiHocSinhApi } from "./trangThaiHocSinhApi";
import { trangThaiPhuHuynhApi } from "./trangThaiPhuHuynhApi";
import { tuanApi } from './tuanApi';
import { uploadApi } from './uploadApi';
import { thongTinCbnvApi } from "./thongTinCbnvApi";
import { conCbnvApi } from "./conCbnvApi";
import { boDoiCongAnApi } from "./boDoiCongAnApi";
export const apiWrapper = {
    account: accountApi,
    uploadFile: uploadApi,
    categorySource: categorySourceApi,
    lopBoMon: lopBoMonApi,
    lopBoMonHocSinh: lopBoMonHocSinhApi,
    dictionary: dictionaryApi,
    monHoc: monHocApi,
    lop: lopApi,
    lopChuNhiem: lopChuNhiemApi,
    hocSinh: hocSinhApi,
    giaoVien: giaoVienApi,
    toKhoi: toKhoiApi,
    soNhanXetItem: soNhanXetItemApi,
    soNhanXet: soNhanXetApi,
    giaoVienNhanXet: giaoVienNhanXetApi,
    loaiPhong: loaiPhongApi,
    phongHoc: phongHocApi,
    thoiKhoaBieu: thoiKhoaBieuApi,
    thoiKhoaBieuChiTietApi: thoiKhoaBieuChiTietApi,
    thu: thuApi,
    tuan: tuanApi,
    tiet: tietApi,
    plNamHoc: plNamHocApi,
    hocKy: hocKyApi,
    appMenu: appMenuApi,
    appMenuNhom: appMenuNhomApi,
    appMenuTruong: appMenuTruongApi,
    appAccount: appAccountApi,
    appBaiViet: appBaiVietApi,
    appBaiVietTrangThai: appBaiVietTrangThaiApi,
    appXinNghi: appXinNghiApi,
    appYeuCauHoTro: appYeuCauHoTroApi,
    notify: notifyApi,
    diemDanh: diemDanhApi,
    diemDanhStatus: diemDanhStatusApi,
    nhanXetHangNgay: nhanXetHangNgayApi,
    localizedResource: localizedReourceApi,
    baiTapWrapper: {
        type: baiTapTypeApi,
        baiTap: baiTapApi,
        baiTapKetQua: baiTapKetQuaApi
    },
    thaiDoHocTapWrapper: {
        thaiDoHocTap: thaiDoHocTapApi,
        thaiDoHocTapTieuChi: thaiDoHocTapTieuChiApi
    },
    thongTu: thongTuApi,
    diemVanMinhKetQua: diemVanMinhKetQuaApi,
    diemVanMinhTieuChi: diemVanMinhTieuChiApi,
    danhGia: {
        dinhKy: {
            nlpc: dgdkKetQuaNlpcApi,
            hocTap: dgdkKetQuaHocTapApi
        },
        thuongXuyen: {
            nlpc: dgtxKetQuaApi,
            hocTap: dgtxKetQuaHocTapApi
        }
    },
    tongHop: {
        dinhKy: tongHopDinhKyApi
    },
    formWrapper: {
        form: formApi,
        formItem: formItemApi,
        formEditor: formEditorApi,
        formEditorType: formEditorTypeApi,
        formRegisterResult: formRegisterResultApi,
        formRegisterResultDetail: formRegisterResultDetailApi
    },
    trangThaiHocSinh: trangThaiHocSinhApi,
    trangThaiPhuHuynh: trangThaiPhuHuynhApi,
    loaiGiayTo: loaiGiayToApi,
    crmSurveyForm: {
        crmSurveyFormQuestion: crmSurveyFormQuestionApi,
        crmSurvey: crmSurveyApi,
        crmSurveyForm: crmSurveyFormApi,
        chienDich: chienDichApi
    },
    crmCategoryWrapper: {
        nguonBietToi: nguonBietToiApi,
        nguonBietToiType: nguonBietToiTypeApi
    },
    crmHocSinh: crmHocSinhApi,
    thucDonWrapper: {
        caAn: foCaAnApi,
        caAnTruong: foCaAnTruongApi,
        monAnChiTiet: foMonAnChiTietApi,
        thucDon: foThucDonApi
    },
    crmPhuHuynh: phuHuynhApi,
    sucKhoe: {
        sucKhoe: sucKhoeApi,
        loaiSucKhoe: loaiSucKhoeApi
    },
    hocSinhAce:hocSinhAceApi,
    hocSinhAceChiTiet:hocSinhAceChiTietApi,
    thongTinCbnv:thongTinCbnvApi,
    conCbnv:conCbnvApi,
    boDoiCongAn:boDoiCongAnApi

}